import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'LD',
  name: 'Lucas D.',
  role: '📍 Lanús',
  quote: 'Me animé a emprender y en la primera semana ya recuperé lo que pagué. Es una locura lo que aprendés en pocos días.'
}, {
  initials: 'DS',
  name: 'Diego S.',
  role: '📍 Mar del Plata',
  quote: 'Todo explicado en criollo, sin vueltas. Ya hice 3 instalaciones y cobré bien. Se paga solo.'
}, {
  initials: 'FR',
  name: 'Fabián R.',
  role: '📍 Entre Ríos',
  quote: 'Lo compré con dudas. Hoy después de una semana ya estoy reparando splits. No lo podía creer.'
}, {
  initials: 'NG',
  name: 'Natalia G.',
  role: '📍 Rosario',
  quote: 'Antes hacía changas sueltas. Ahora tengo mi propio emprendimiento y manejo mis tiempos.'
}];
export function FullTestimonials() {
  return <section className="py-12 md:py-16 px-4 bg-brand-deep" data-id="element-137">
      <div className="max-w-5xl mx-auto" data-id="element-138">
        <h2 className="text-3xl md:text-5xl font-black text-center text-white mb-8 md:mb-12" data-id="element-139">
          Lo que dicen los que ya empezaron 💬
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-140">
          {testimonials.map((t, i) => <div key={i} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl shadow-sm border border-white/10 flex flex-col" data-id="element-141">
              <div className="flex items-center gap-4 mb-6" data-id="element-142">
                <div className="w-14 h-14 bg-brand-primary text-white rounded-full flex items-center justify-center text-xl font-bold flex-shrink-0" data-id="element-143">
                  {t.initials}
                </div>
                <div data-id="element-144">
                  <h3 className="text-xl font-black text-white" data-id="element-145">{t.name}</h3>
                  <p className="text-sm text-blue-50 font-bold" data-id="element-146">{t.role}</p>
                </div>
                <div className="ml-auto flex text-brand-amber" data-id="element-147">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-148" />)}
                </div>
              </div>
              <p className="text-lg text-blue-50 leading-relaxed italic flex-grow" data-id="element-149">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}